import type { StagedFile } from '#uploader/types/staged-file.type';

/**
 * Recomputes `hasDuplicateSuffix` across all staged files.
 * Only files with `isCustomSuffix: false` (auto-assigned suffixes) participate in
 * duplicate validation. Custom-suffixed files always have `hasDuplicateSuffix: false`
 * since the consumer owns their naming — resolved filename uniqueness is the safety net.
 */
export const recomputeDuplicates = (staged: StagedFile[]): StagedFile[] => {
  const suffixCounts = new Map<string, number>();

  for (const stagedFile of staged) {
    if (!stagedFile.isCustomSuffix) {
      suffixCounts.set(stagedFile.suffix, (suffixCounts.get(stagedFile.suffix) ?? 0) + 1);
    }
  }

  return staged.map((stagedFile) => {
    if (stagedFile.isCustomSuffix) {
      return { ...stagedFile, hasDuplicateSuffix: false };
    }

    return { ...stagedFile, hasDuplicateSuffix: (suffixCounts.get(stagedFile.suffix) ?? 0) > 1 };
  });
};
